module.exports = __webpack_public_path__ + "img/manFace.f01f611a.png";